import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7988af8c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7988af8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7988af8c')) {
      api.createRecord('7988af8c', component.options)
    } else {
      api.reload('7988af8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7988af8c&scoped=true&", function () {
      api.rerender('7988af8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/index.vue"
export default component.exports